export default {
  'header.menu.purpose': '協會介紹與宗旨',
  'header.menu.join': '協會規範與入會須知',
};
